module.exports = __webpack_public_path__ + "static/sasu-tarkoma-77bab1360475e96943b12e535424272e.jpg";